import React from "react";
import { Layout } from "../Layout";
import { Heading } from "@chakra-ui/react";

export default function NotFoundPage() {
  return (
    <>
      <Heading>Not found page</Heading>
    </>
  );
}
